import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface TwinPartsKeyType {
  plural: LocalesKey;
  createButton: LocalesKey;
  createTitle: LocalesKey;
  editTitle: LocalesKey;
  deleteTitle: LocalesKey;
  deleteWarning: LocalesKey;
  company: LocalesKey;
}

// F10-pages (task #13): standalone /twins/parts grid. Column headers in
// twinPartsColumnDefs are raw strings, matching the twinAssets grid
// convention (AG Grid headerName is not translated in this domain) — these
// keys cover the page/drawer chrome, not the grid header row.
export const twinPartsKeys = keyPathMirror<TwinPartsKeyType, string>(
  {
    plural: null,
    createButton: null,
    createTitle: null,
    editTitle: null,
    deleteTitle: null,
    deleteWarning: null,
    company: null
  },
  'models.twinParts.'
);
